export default __webpack_public_path__ + "static/media/mahin-arafath-500-500.00b5faa5.png";